// @flow
import types from "./types";
import type {Action} from "../DucksUtils";
import {handleTokenUpdateData, StopSelection} from "./utils";
import type {LatLngLiteral} from "../../../Utils/MapUtils";
import TokenDataTypes from "../TokenData/types";
import ServiceConfigTypes from "../ServiceConfig/types";
import type {StopSelectionType} from "./utils";
import type {LatLngType} from "../../../Utils/AppUtils";

type MandatoryKeys = {|
    origin_type: LatLngType,
    dest_type: LatLngType,
    passenger_count: number,
|}

type OptionalKeys = {|

    origin_address?: string,
    origin_selection?: StopSelectionType,
    origin_search?: boolean,
    origin_lat?: number,
    origin_lng?: number,
    originTerminals?: Array<{ latlng: LatLngLiteral, details: string, label: string }>,

    dest_address?: string,
    dest_search?: boolean,
    dest_lat?: number,
    dest_lng?: number,
    dest_selection?: StopSelectionType,
    destTerminals?: Array<{ latlng: LatLngLiteral, details: string, label: string }>,

    city_id?: number,
|};

export type CurrentRequest = { ...MandatoryKeys, ...OptionalKeys } | OptionalKeys;

export const CurrentRequestDefault = {
    origin_selection: StopSelection.NONE,
    dest_selection: StopSelection.NONE,
};


const CurrentRequestReducer = (currentRequest: CurrentRequest = CurrentRequestDefault, action: Action): CurrentRequest => {
    const type: string = action.type;
    const payload = action.payload;
    switch (type) {
        case ServiceConfigTypes.SERVICE_ORIGIN_TERMINALS_SET:
            return {
                ...currentRequest,
                originTerminals: payload
            };
        case ServiceConfigTypes.SERVICE_DEST_TERMINALS_SET:
            return {
                ...currentRequest,
                destTerminals: payload
            };
        case TokenDataTypes.TOKEN_DATA_UPDATE:
            return handleTokenUpdateData(currentRequest, payload);

        case types.REQUEST_ORIGIN_SET:
            return {
                ...currentRequest,
                origin_lat: payload.latlng.lat,
                origin_lng: payload.latlng.lng,
                origin_selection: payload.selection,
                origin_address: payload.label || currentRequest.origin_address,
            };
        case types.REQUEST_DEST_SET:
            return {
                ...currentRequest,
                dest_lat: payload.latlng.lat,
                dest_lng: payload.latlng.lng,
                dest_selection: payload.selection,
                dest_address: payload.label || currentRequest.dest_address,
            };
        case types.ORIGIN_SUGGESTION_SET:
            return {
                ...currentRequest,
                origin_address: payload.address,
                origin_lat: payload.latlng.lat,
                origin_lng: payload.latlng.lng,
                origin_search: false,
            };
        case types.DEST_SUGGESTION_SET:
            return {
                ...currentRequest,
                dest_address: payload.address,
                dest_lat: payload.latlng.lat,
                dest_lng: payload.latlng.lng,
                dest_search: false,
            };
        case types.ORIGIN_LABEL_CLICK:
            return {
                ...currentRequest,
                origin_search: currentRequest.origin_selection === StopSelection.NONE,
                origin_selection: StopSelection.NONE,
            };
        case types.DEST_LABEL_CLICK:
            return {
                ...currentRequest,
                dest_search: currentRequest.dest_selection === StopSelection.NONE,
                dest_selection: StopSelection.NONE,
            };
        case types.CANCEL_SEARCH_CLICK:
            return {
                ...currentRequest,
                dest_search: false,
                origin_search: false,
            };
        case types.ORIGIN_LATLNG_SET:
            return {
                ...currentRequest,
                origin_lat: payload.lat,
                origin_lng: payload.lng,
            };
        case types.DEST_LATLNG_SET:
            return {
                ...currentRequest,
                dest_lat: payload.lat,
                dest_lng: payload.lng,
            };
        case types.ORIGIN_ADDRESS_SET:
            return {
                ...currentRequest,
                origin_address: payload,
            };
        case types.DEST_ADDRESS_SET:
            return {
                ...currentRequest,
                dest_address: payload,
            };
        case types.ORIGIN_DESELECT:
            return {
                ...currentRequest,
                origin_lat: undefined,
                origin_lng: undefined,
                origin_selection: StopSelection.NONE,
            };
        case types.DEST_DESELECT:
            return {
                ...currentRequest,
                dest_lat: undefined,
                dest_lng: undefined,
                dest_selection: StopSelection.NONE,
            };
        case types.CANCEL_ORIGIN_TERMINALS_CLICK:
            return {
                ...currentRequest,
                originTerminals: undefined,
            };
        case types.CANCEL_DEST_TERMINALS_CLICK:
            return {
                ...currentRequest,
                destTerminals: undefined,
            };

        default:
            return currentRequest;
    }
};

export default CurrentRequestReducer;





// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentRequest/reducers.js